import type { IRootScopeService } from 'angular';
import angular from 'angular';

import type {
  RecipientTypes,
  RecipientType,
} from '@app/offer/OfferMessageSentPage/types';
import type OfferEmailDelivery from '@bb/domain/dist/types/OfferEmailDelivery';

import template from './email_delivery_log.html';

type DataType = OfferEmailDelivery[] | RecipientType[];
type LogType = 'appointment' | 'offer';

class EmailDeliveryLogController implements ng.IOnInit {
  private deliveryLog: OfferEmailDelivery[];

  private type: LogType;

  private recipients: RecipientType[];

  private unsubscribedAgents: RecipientType[];

  private data: DataType;

  private emptyText: string;

  private currentTab: RecipientTypes = 'recipients';

  // eslint-disable-next-line no-useless-constructor
  constructor(private $rootScope: IRootScopeService) {}

  private dataMap: Record<RecipientTypes, DataType>;

  private emptyTextMap: Record<
    LogType,
    string | Record<RecipientTypes, string>
  >;

  changeCurrentTab = (newTab: RecipientTypes) => {
    this.currentTab = newTab;
    this.$rootScope.$evalAsync(() => {
      this.data = this.dataMap[this.currentTab];
      this.setEmptyText();
    });
  };

  setEmptyText = () => {
    const placeholderEmptyText = this.emptyTextMap[this.type];
    if (typeof placeholderEmptyText === 'string') {
      this.emptyText = placeholderEmptyText;
    } else {
      this.emptyText = placeholderEmptyText[this.currentTab];
    }
  };

  $onInit() {
    this.dataMap = {
      recipients: this.deliveryLog || this.recipients,
      removed: [],
      unsubscribed: this.unsubscribedAgents,
    };
    this.emptyTextMap = {
      appointment: 'No email delivery logs for this showing.',
      offer: {
        recipients: 'No agents are subscribed to this offer.',
        removed: '',
        unsubscribed: 'No agents are unsubscribed from this offer.',
      },
    };
    this.data = this.dataMap[this.currentTab];
    this.setEmptyText();
  }
}

EmailDeliveryLogController.$inject = ['$rootScope'];

angular.module('bb.appointments').component('emailDeliveryLog', {
  transclude: true,
  bindings: {
    deliveryLog: '<',
    timezone: '<',
    recipients: '<',
    type: '@',
    unsubscribedAgents: '<',
  },
  controller: EmailDeliveryLogController,
  controllerAs: 'vm',
  template,
});
